var map = {
	"./ConferenceYear2015.png": 145,
	"./ConferenceYear2016.png": 146,
	"./ConferenceYear2017.png": 147,
	"./ConferenceYear2018.png": 148,
	"./ConferenceYear2019.png": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;